import React from "react";
import { HiOutlineCog } from "react-icons/hi";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(HiOutlineCog).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const SettingsIcon = (props) => {
  return <StyledIcon {...props} />;
};

SettingsIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default SettingsIcon;
